import React, { useState, useEffect, useRef } from "react";
import API, { BASE_URL } from "../api/Api"; 

const UpcomingProjects = () => {
  const [activeTab, setActiveTab] = useState("All Projects");
  const [projects, setProjects] = useState([]);
  const sliderRef = useRef(null);

  /*  FETCH PROJECTS  */
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await API.get("/upcoming_projects");
        setProjects(res.data.data || []);
      } catch (err) {
        console.error("Upcoming Projects Error:", err);
      }
    };

    fetchProjects();
  }, []);

  /*  AUTO SCROLL  */
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let speed = 1.5;
    let animationId;

    const autoScroll = () => {
      slider.scrollLeft += speed;

      if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
        slider.scrollLeft = 0;
      }

      animationId = requestAnimationFrame(autoScroll);
    };

    animationId = requestAnimationFrame(autoScroll);

    const stop = () => cancelAnimationFrame(animationId);
    const start = () => (animationId = requestAnimationFrame(autoScroll));

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);

    return () => {
      cancelAnimationFrame(animationId);
      slider.removeEventListener("mouseenter", stop);
      slider.removeEventListener("mouseleave", start);
    };
  }, [projects]);

  /*  FILTER  */
 

  const formatYear = (date) => {
    if (!date || date === "0000-00-00") return "TBD";
    return new Date(date).getFullYear();
  };

  const formatAmount = (amount) => {
  if (!amount) return "₹0";

  const num = Number(amount);

  if (num >= 10000000) {
    return `₹${(num / 10000000).toFixed(2)} Cr`;
  } else if (num >= 100000) {
    return `₹${(num / 100000).toFixed(2)} Lakh`;
  } else {
    return `₹${num.toLocaleString("en-IN")}`;
  }
};
  return (
    <section className="ucsr-projects-section container">

      {/* TOP HEADER */}
      <div className="ucsr-section-top">
        <div>
          <span className="ucsr-badge-next">
            <i className="fa-regular fa-calendar"></i> WHAT’S NEXT
          </span>
          <h2 className="ucsr-section-title">Upcoming CSR Projects</h2>
        </div>

        
      </div>

      {/* PROJECT SLIDER */}
      <div className="ucsr-projects-slider" ref={sliderRef}>

       
        {[...projects,...projects].map((project, index) => (
          <div className="ucsr-project-card" key={index}>
            <div className="ucsr-project-img">
              <img
                src={
                  project.image
                    ? `${BASE_URL}/assets/images/${project.image}`
                    : "https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
                }
                alt="CSR Project"
              />

              {/* <span className="ucsr-status-badge">
                {project.status === "Approved"
                  ? "Active"
                  : "Planning Stage"}
              </span> */}

              <span className="ucsr-category-badge">
                 {project.department}
              </span>
            </div>

            <div className="ucsr-project-content">
              <div>
                <h3 className="ucsr-project-title">
                  {project.title}
                </h3>

             <p
  className="ucsr-project-desc"
  dangerouslySetInnerHTML={{
    __html:
      project.description1
        ?.replace(/<[^>]+>/g, "")
        .substring(0, 100) + "...",
  }}
/>

                <div className="ucsr-project-location">
                  <i className="fa-solid fa-location-dot"></i>
                  {project.location || "Pan India"}
                </div>

                <div className="ucsr-project-meta">
                  <div>
                  Estimated Cost: <strong>{formatAmount(project.budget)}</strong>
                  </div>
                  <div>
                    Timeline:{" "}
                    <strong>
                      {formatYear(project.start_year)}–
                      {formatYear(project.end_year)}
                    </strong>
                  </div>
                </div>
              </div>

              <a
                href={`/projects/${project.project_id}`}
                className="ucsr-project-btn"
              >
                View Details <i className="fa-solid fa-arrow-right"></i>
              </a>
            </div>
          </div>
        ))}

      </div>
    </section>
  );
};

export default UpcomingProjects;
